import React from 'react';
import { LockOutlined } from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/accessRulesCard.module.scss';

function AccessRulesCardHeader({ readOnly = false }) {
    return (
        <div className={styles.header}>
            <span className={styles.headerIcon} aria-hidden="true">
                <LockOutlined />
            </span>
            <Text as="span" size="s" className={styles.headerTitle}>
                {readOnly ? 'Access Rules' : 'Manage Access Rules'}
            </Text>
        </div>
    );
}

export default AccessRulesCardHeader;
